<div class="bg-white pb-2">
  <h5 class="mb-0 text-dark fs-6">Document Management</h5>
  <!-- Global Request Information Button -->
  <div v-if="has_unverified_documents" class="mt-4 d-flex pe-3">
    <button class="btn btn-primary-dark btn-sm text-xxs shadow" data-bs-toggle="modal"
      data-bs-target="#request_information" @click="open_request_modal">
      Request Information
    </button>
  </div>
</div>

<div class="border p-2 table-border-color rounded-lg">
  <div v-if="table_safe_documents.length > 0" class="table-responsive text-xxs">
    <table class="table table-hover" id="document_management_table">
      <thead class="custom-header">
        <tr>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">NO</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Document Name</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Section Name</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Date Uploaded</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Status</th>
          <th class="text-uppercase text-xs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in table_safe_documents" :key="index">
          <td class="text-xs text-start">{{ index + 1 }}</td>
          <td class="text-xxs text-start">{{ row.file_name }}</td>
          <td class="text-xxs text-start">{{ row.section }}</td>
          <td class="text-xxs text-start">{{ format_date(row.submitted_on) }}</td>
          <td class="text-xxs">
            <span v-if="row.is_verified" class="badge bg-success text-white">Manually Verified</span>
            <span v-else class="badge bg-danger text-white">Pending Verification</span>
          </td>
          <td class="d-flex flex-nowrap gap-2 align-items-center">
            <button class="btn btn-primary-dark btn-sm text-xxs shadow me-1" @click="preview_file(row.presigned_url)">
              Preview
            </button>

            <button v-if="!row.is_verified" class="btn btn-primary-dark btn-sm text-xxs shadow"
              @click="verify_document(row)">
              Manually Verify
            </button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  <div v-else class="p-4 text-center text-muted">
    No documents available.
  </div>
</div>

<div v-if="preview_modal"  @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="preview_url" @close="close_the_file_preview" :key="preview_url" />
</div>

<teleport to="body">
<div class="modal fade" id="request_information" tabindex="-1" aria-labelledby="request_information_label"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="request_information_label">Request Information</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Current section's answered files -->
        <div v-if="answered_file_questions.length > 0" class="mb-3">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <p class="text-xxs fw-bold mb-0">Files in current section:</p>
          </div>
          <div class="mt-3">
            <div v-for="question in answered_file_questions" :key="question.id" class="file-list-item">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="bi bi-file-earmark me-2 text-primary"></i>
                  <div>
                    <div class="text-xxs">{{ question.question_text }}</div>
                  </div>
                </div>
                <input type="checkbox" :value="question.section_question_id"
                  :data-requested_field_text="question.question_text" class="form-check-input ms-3"
                  @change="toggle_requested_field($event, question)" />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-form-group form-group mb-2 d-flex flex-column">
          <label for="request_info_note" class="modal-form-label form-label text-start text-xxs">Notes</label>
          <textarea v-model="request_info_note" id="request_info_note"
            class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" rows="4">
          </textarea>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow"
          @click="request_information">Request</button>
      </div>
    </div>
  </div>
</div>
</teleport>